import Paragraph from '@intercom/embercom-composer/blocks/types/paragraph';
import { and, not, notEmpty } from '@ember/object/computed';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['composer-image-text-editor'],
  blocksTitle: null,
  blocksText: null,
  imageUrl: null,
  isEditMode: false,
  hasNoContent: not('currentEditableObject.hasValidContent'),
  init() {
    this._super(...arguments);
    if (this.get('hasNoContent')) {
      this.set('isEditMode', true);
    }
  },
  setContentOnOpen: Em.observer({
    dependentKeys: ['isEditMode'],
    fn() {
      if (this.get('isEditMode') && this.get('currentEditableObject.hasValidContent')) {
        this.set('blocksTitle', this.generateBlockFromText(this.get('currentEditableObject.title')));
        this.set('blocksText', this.generateBlockFromText(this.get('currentEditableObject.text')));
        this.set('imageUrl', this.get('currentEditableObject.imageUrl'));
      }
    },
    sync: true
  }),
  generateBlockFromText(text) {
    let block = Paragraph.create({
      text,
      type: 'paragraph',
      config: this.get('config')
    });
    return [block];
  },
  syncAndFocus() {
    if (this.isDestroying) {
      return;
    }
    this.moveSelectionPastEntityOrBlock?.();
  },
  hasValidText: notEmpty('blocksText.firstObject.text'),
  hasValidImageUrl: notEmpty('imageUrl'),
  hasValidContent: and('hasValidText', 'hasValidImageUrl'),
  actions: {
    edit() {
      this.set('isEditMode', true);
    },
    updateTitleBlocks() {
      let blocks = this.composerTitle.getBlocks();
      this.set('blocksTitle', blocks);
    },
    updateTextBlocks() {
      let blocks = this.composerText.getBlocks();
      this.set('blocksText', blocks);
    },
    setImageUrl(url) {
      this.set('imageUrl', url);
    },
    save() {
      if (this.get('hasValidContent')) {
        this.get('currentEditableObject').set('title', this.get('blocksTitle.firstObject.text'));
        this.get('currentEditableObject').set('text', this.get('blocksText.firstObject.text'));
        this.get('currentEditableObject').set('imageUrl', this.get('imageUrl'));
        this.set('isEditMode', false);
        this.syncAndFocus();
      }
    },
    delete() {
      this.set('isEditMode', false);
      this.get('composerState').backspace();
      this.syncAndFocus();
    },
    cancel() {
      if (this.get('hasNoContent')) {
        this.send('delete');
        return;
      }
      this.set('isEditMode', false);
      this.syncAndFocus();
    },
    hideEditor(id) {
      this.hideEditor?.(id);
    },
    moveSelectionPastEntityOrBlock() {
      this.get('composerState').moveSelectionPastEntityOrBlock();
    }
  }
});